import {
  OCCUPANCY_REQUEST, OCCUPANCY_SUCCESS, OCCUPANCY_FAILURE
} from '../actions/occupancy'

const INITIAL_STATE = {
  data: null, error: null, loading: false
}

// Keeps the previous data during a refetch so the live screen can poll
// without flashing back to a loading state.
const occupancyReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case OCCUPANCY_REQUEST:
      return {
        ...state,
        error: null, loading: true
      }
    case OCCUPANCY_SUCCESS:
      return {
        ...state,
        data: action.response, error: null, loading: false
      }
    case OCCUPANCY_FAILURE:
      return {
        ...state,
        error: action.error, loading: false
      }
    default:
      return state
  }
}

export default occupancyReducer
